import React, {Component} from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class ModalConfirm extends Component{
    render(){
        return(
            <Modal className="modal-dialog-centered" isOpen={this.props.isOpen} toggle={this.props.toggler}>
                <ModalHeader toggle={this.props.toggler}>{this.props.title}</ModalHeader>
                <ModalBody>
                    <p style={{whiteSpace: 'pre-line'}}>{this.props.message}</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="link" onClick={this.props.toggler}>Cancelar</Button>
                </ModalFooter>
            </Modal>
        )
    }
}
export default ModalConfirm


// WEBPACK FOOTER //
// ./resources/assets/js/components/common/ModalInfo.jsx